import awards from "../../shared/it.awards";
import branded_quotes from "../../shared/it.branded-quotes";
import verticals from "./it-education-primary.verticals";
const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};
export default ({ page, strings }) => {
    switch (page) {
        case "it-education-primary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contatti | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/contatti/",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-education-primary-home":
            return {
                page,
                helmet: {
                    meta_title:
                        "L’apprendimento delle lingue  dalla scuola materna alla scuola secondaria superiore | Rosetta Stone",
                    meta_description:
                        "Le soluzioni di apprendimento linguistico di Rosetta Stone per la scuola primaria e secondaria  vanno di pari passo e si integrano con l'insegnamento in classe e sono disponibili in qualsiasi momento per gli studenti che desiderano apprendere  o migliorare la propria conoscenza dell'inglese e di altre lingue straniere.",
                    canonical_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-education-primary-solutions":
            return {
                page,
                helmet: {
                    meta_title:
                        "Programmi di apprendimento linguistico online per l´istruzione primaria e secondaria | Rosetta Stone",
                    meta_description:
                        "I programmi di apprendimento linguistico on line di Rosetta Stone motivano gli studenti d’inglese  e delle altre lingue straniere, dando loro la fiducia e la sicurezza necessarie per esprimersi. Richiedi le nostre tariffe.",
                    canonical_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/soluzioni/",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-education-primary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-education-primary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-education-primary-404":
            return {
                page,
                helmet: {
                    meta_title: "Sito non trovato | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/404",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
